// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1CNnr","insightsList":"newBusinessInsightsMenu_insightsList__2_vmH","active":"newBusinessInsightsMenu_active__3Dqd5"};